import React from "react";
import NavbarMain from "./NavbarMain";
import Footer from "./Footer";
import { useMediaQuery } from "react-responsive";
import NavbarMainMobile from "./NavbarMainMobile";
import SuccessContent from "./SuccessContent";
import SuccessContentMobile from "./SuccessContentMobile";

const Success = () => {
  const activeCategory = "learnmore";
  const activeCategoryMobile = "learnmore";
  const isMobile = useMediaQuery({ query: "(max-width: 1000px)" });

  return (
    <div>
      {isMobile ? (
        <>
          {" "}
          <NavbarMainMobile activeCategoryMobile={activeCategoryMobile} />
          <SuccessContentMobile />
        </>
      ) : (
        <>
          <NavbarMain activeCategory={activeCategory} />
          <SuccessContent />
          <Footer />
        </>
      )}
    </div>
  );
};

export default Success;
